// TODO: We should get rid of this eventually (a few months?) because we no longer track user views via localstorage

import axios from 'axios';

var userSignedIn = document.querySelector('body').getAttribute('data-user-signed-in') == 'true'

if(userSignedIn && localStorage.getItem('resource_user_views') !== null) {
  // TODO: Be sure to localize this string once we localize this route
  if (window.location.href.indexOf('/account/dashboard') !== -1) {
    var realTime = true;
  } else {
    var realTime = false;
  }

  const viewsData = {
    views: encodeURIComponent(localStorage.getItem('resource_user_views')),
    realtime: realTime
  }

  var csrfToken = document.querySelector('meta[name=csrf-token]').content;
  axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;

  axios.post('/api/v1/resource-user-views/import', viewsData)
    .then(() => {
      localStorage.removeItem('resource_user_views');
      if (realTime) {
        location.reload();
      }
    });
}
